export default "__VITE_ASSET__63658ec3__"